import React from "react";

import { getOrderHistory }
  from '../../../helpers/historyOrder'

import OrderCard
  from './OrderCard'

import ReactLoading
  from 'react-loading';

import NotFoundItems
  from './NotFoundItems'

class Calls extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:true,
      callsItems: []
    };
  }

  componentDidMount() {
    getOrderHistory(this.fetchOrderHistory.bind(this), { type: "call" })
  }

  componentWillReceiveProps(newProps) {
    if( newProps.search !== this.props.search ||
        newProps.sort !== this.props.sort ||
        newProps.startDate !== this.props.startDate ||
        newProps.endDate !== this.props.endDate ||
        newProps.page !== this.props.page) {
      this.setState({loading: true})
      getOrderHistory(this.fetchOrderHistory.bind(this),
        {
          type: "call",
          page: newProps.page,
          search: newProps.search,
          sort: newProps.sort,
          startDate: newProps.startDate,
          endDate: newProps.endDate
        }
      )
    }
  }

  fetchOrderHistory(data) {
    this.setState({callsItems: data, loading: false})
    this.props.addObjectItems(data)
  }

  displayOrders() {
    let { loading, callsItems } = this.state
    let { data } = callsItems
    let { translate } = this.props

    if(data.length > 0) {
      return (
        data.map((item) => {
          return (
            <OrderCard
              key={item.id}
              item={item}
            />
          )
        })
      )
    } else {
      return (
        <NotFoundItems
          icon={"call"}
          objectName={"calls"}
          title={translate("settings.order_history.not_found_items.calls_title")}
          description={translate("settings.order_history.not_found_items.description")}
        />
      )
    }
  }

  render() {
    let { loading } = this.state
    if(loading) {
      return (
        <div style={{ height: 200, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <ReactLoading type="spin" color="#bea58b"/>
        </div>
      )
    }

    return (
      <div className="settings-history-list">
        <div className="settings-history-list-wrap">
          {this.displayOrders()}
        </div>
      </div>
    )
  }
}

export default Calls;
